import { Spacer } from '@zillow/constellation';
import { Paragraph, Text } from '@zillow/constellation-10';

type Props = {
  outcomeStats: number;
  source: string;
};

const WizardTipContent = ({ outcomeStats, source }: Props) => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph>
        Properties that allow pets can receive up to {outcomeStats}% more contacts than those that don&apos;t, based on
        data for other listings with a similar price.
      </Paragraph>
      <Spacer marginTop="sm">
        <Text textStyle="body-xs" color="text.subtle">
          {source}
        </Text>
      </Spacer>
    </div>
  );
};

export default WizardTipContent;
